'use client';

import Image from 'next/image';
import { cn } from '@/lib/utils';

interface PlatformIconProps {
  platformId: string;
  className?: string;
  size?: number;
}

export function PlatformIcon({ platformId, className, size = 18 }: PlatformIconProps) {
  // Map platform IDs to image paths
  const getIconPath = (id: string) => {
    const iconMap: Record<string, string> = {
      linkedin: '/images/logos/linkedin.png',
      apollo: '/images/logos/apollo.png',
      crunchbase: '/images/logos/crunchbase.png',
      x: '/images/logos/x.png',
    };

    return iconMap[id] || null;
  };

  const iconPath = getIconPath(platformId);

  if (!iconPath) {
    return null;
  }

  return (
    <Image
      src={iconPath}
      alt={`${platformId} icon`}
      width={size}
      height={size}
      className={cn('inline-block rounded-sm', className)}
      style={{ objectFit: 'contain' }}
    />
  );
}
